import { render, staticRenderFns } from "./rollercoin.vue?vue&type=template&id=7472df3a&scoped=true"
import script from "./rollercoin.vue?vue&type=script&lang=js"
export * from "./rollercoin.vue?vue&type=script&lang=js"
import style0 from "./rollercoin.vue?vue&type=style&index=0&id=7472df3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7472df3a",
  null
  
)

export default component.exports